module.exports = __webpack_public_path__ + "static/4-d63ac5139f2f750ce44365ca29a80400.jpg";